import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DraftFunction } from 'use-immer';

import { WizardValidationError } from '@/types/Wizard';

import ErrorTag from '@/components/elements/error-tag';

import classes from './styles.module.scss';

interface Props {
    password: string;
    confirmPassword: string;
    updatePassword: (
        arg: Record<string, string> | DraftFunction<Record<string, string>>
    ) => void;
    validationErrors: WizardValidationError[];
}

export default function AccountDetails({
    password,
    confirmPassword,
    updatePassword,
    validationErrors,
}: Props) {
    const { t } = useTranslation();

    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        updatePassword((draft) => {
            draft[name] = value;
        });
    };

    const formErrors = useMemo(() => {
        const inputNames: string[] = [
            'password',
            'confirmPassword',
            'passwordMissmatch',
            'passwordInvalid',
        ];

        return validationErrors?.filter((error) => inputNames.includes(error.name));
    }, [validationErrors]);

    return (
        <div>
            <span className={`${classes.header_text}`}>
                {t('wizard:accountDetails:title')}
            </span>

            {formErrors.map((error, index) => (
                <ErrorTag key={`${index}_error_idx`} error={error} />
            ))}

            <div className={`${classes.form_container}`}>
                <input
                    type='password'
                    name='password'
                    placeholder={t('wizard:accountDetails:password')}
                    onChange={handlePasswordChange}
                    value={password}
                    minLength={8}
                    maxLength={20}
                />

                <input
                    type='password'
                    name='confirmPassword'
                    placeholder={t('wizard:accountDetails:confirmPassword')}
                    onChange={handlePasswordChange}
                    value={confirmPassword}
                    minLength={8}
                    maxLength={20}
                />
            </div>
            <label className={`${classes.copy}`}>{t('wizard:accountDetails:copy')}</label>
        </div>
    );
}
